import { Component, inject, OnDestroy, OnInit } from '@angular/core';

import { GlobalHeroComponent } from '../../shared/components/global-hero/global-hero.component';
import { JumpToComponent } from '../../shared/components/jump-to/jump-to.component';
import { WhyScreenComponent } from './why-screen/why-screen.component';
import { CardsComponent } from './cards/cards.component';
import { FindingsComponent } from './findings/findings.component';
import { FactsComponent } from './facts/facts.component';
import { AccordionComponent } from './accordion/accordion.component';
import { CtaBottomComponent } from '../../shared/components/cta-bottom/cta-bottom.component';
import { appPaths } from '../../app.paths';
import { ScrollSpyService } from '../../shared/services/scroll-spy.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { T1dStoriesComponent } from './t1d-stories/t1d-stories.component';
import { ReviewBarComponent } from '../../shared/components/review-bar/review-bar.component';

@Component({
  selector: '[costs-not-knowing]',
  imports: [
    CommonModule,
    GlobalHeroComponent,
    JumpToComponent,
    WhyScreenComponent,
    CardsComponent,
    T1dStoriesComponent,
    FindingsComponent,
    FactsComponent,
    AccordionComponent,
    CtaBottomComponent,
    ReviewBarComponent
  ],
  templateUrl: './costs-not-knowing.component.html',
  styleUrl: './costs-not-knowing.component.scss',
})
export class CostsNotKnowingComponent implements OnInit, OnDestroy {
  scrollSpyService = inject(ScrollSpyService);

  activeSection$!: Observable<string | null>;

  heroData = {
    backgroundImageDesktop: 'hero-not-knowing',
    titleText: 'The real',
    bodyTextDesktopWidth: '',
    titleColorText: `costs <span class="text-dark">of</span> not knowing`,
    bodyText:
      'Screening for type 1 diabetes (T1D) today can <br class="d-none d-lg-inline" />help spot symptoms early and reduce the risk of <br class="d-none d-lg-inline" />dangerous complications.',
    sillHouetteImage: 'hero-sillhouette-not-knowing',
    sillhouette: {
      mobile: {
        width: 293,
        top: 13,
        left: 49,
      },
      tablet: {
        width: 305,
        top: 2,
        left: 65,
      },
      desktop: {
        width: 572,
        height: 338,
        top: 4,
        left: 122,
      },
    },
    sillhouetteAlt: 'Cara Loren Van Brocklin posing with her family',
  };

  jumpToData = [
    {
      buttonLabel: 'Avoid serious complications',
      buttonUrl: '/',
      buttonFragment: 'benefits-of-knowing',
    },
    {
      buttonLabel: 'T1D stories',
      buttonUrl: '/',
      buttonFragment: 't1d-stories',
    },
    {
      buttonLabel: 'What real patients are saying',
      buttonUrl: '/',
      buttonFragment: 'what-patients-say',
    },
  ];

  ctaBottomData = {
    icon: 'age',
    alt: 'An hourglass timer',
    title: 'Interested in getting screened? <br/>Now’s the time.',
    button: {
      buttonLabel: 'Discover your options',
      buttonUrl: appPaths.HOWTOSCREEN + '/',
      openInNewTab: false,
      buttonIcon: 'right-icon',
    },
  };

  ngOnInit(): void {
    const sectionIds = this.jumpToData.map((item) => item.buttonFragment);
    this.scrollSpyService.initObserver(sectionIds);

    this.activeSection$ = this.scrollSpyService.activeSection$;
  }

  ngOnDestroy(): void {
    this.scrollSpyService.disconnectObserver();
  }
}
